import { render } from "./usuarios.vue?vue&type=template&id=659d7ade"
import script from "./usuarios.vue?vue&type=script&lang=js"
export * from "./usuarios.vue?vue&type=script&lang=js"
script.render = render

export default script